// extracted by mini-css-extract-plugin
export default {"billing_table_wrapper":"BillingLabTable_billing_table_wrapper__PJsLj"};